module.exports = __webpack_public_path__ + "img/logo1 (29).e12ce4a8.jpg";